import { LicenseInfo } from "@mui/x-license-pro";

import { viteEnv } from "utils/vite-env.util";

LicenseInfo.setLicenseKey(viteEnv.VITE_MUI_LICENSE || "");
